"use strict";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Intentions = require('./Intentions');
/**
 * JS-son agent generation function
 * @param {string} id unique identifier for the agent
 * @param {object} beliefs initial beliefs of the agents
 * @param {object} desires the agent's desires
 * @param {array} plans the agent's plans
 * @param {function} determinePreferences preference function generator; by default
                                          (if no function is provided), the preference function
                                          turns all desires into intentions
 * @returns {object} JS-son agent object
 */


function Agent(id, beliefs, desires, plans) {
  var _this2 = this;

  var determinePreferences = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (beliefs, desires) {
    return function (desireKey) {
      return desires[desireKey](beliefs);
    };
  };
  this.id = id;
  this.beliefs = beliefs;
  this.desires = desires;
  this.plans = plans;
  this.preferenceFunction = determinePreferences;
  this.isActive = true;

  this.next = function (beliefs) {
    var _this = this;

    this.beliefs = _objectSpread({}, this.beliefs, beliefs);

    if (this.isActive) {
      if (Object.keys(desires).length === 0) {
        this.intentions = this.beliefs;
      } else {
        this.intentions = Intentions(this.beliefs, this.desires, this.preferenceFunction);
      }

      return this.plans.map(function (plan) {
        return plan.run(_this.intentions);
      }).filter(function (result) {
        return result !== null;
      });
    }
  };

  this.stop = function () {
    return _this2.isActive = false;
  };

  this.start = function () {
    return _this2.isActive = true;
  };
}

module.exports = Agent;